import { axiosMock, hasUrlMock } from '../client';
import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from '../apiDictionary';
import { mockPaginate } from 'src/mocks/paginate';
import { faker } from '@faker-js/faker';
import { ClinicalTrialReport } from '@restore/clinicalTrialReports/clinicalTrialReports.types';

export function createRandomReport(): ClinicalTrialReport {
  return {
    id: faker.string.uuid(),
    reviewStatus: 'NEW',
    readers: [faker.string.alphanumeric()],
    reportName: faker.string.alpha(),
    reportId: faker.string.uuid(),
    createdDate: faker.date.past(),
    reportTemplateCode: faker.string.alpha(),
    reportStatus: faker.string.uuid(),
    clinicalTrialId: faker.string.numeric(),
    patientId: faker.string.numeric(),
    patientCode: faker.string.alphanumeric(),
    visitId: faker.string.alphanumeric(),
    visitName: faker.string.alpha(),
    visitOrder: faker.number.int(),
    taskSignDate: faker.date.past(),
    reportSignDate: faker.date.past(),
    readingCode: faker.string.alphanumeric(),
    assigneeIds: [faker.string.alphanumeric()],
  };
}

export function createRandomReportList(count: number): ClinicalTrialReport[] {
  return faker.helpers.multiple(createRandomReport, { count });
}

export const fetchReportsMock = async (id: string) => {
  if (!hasUrlMock(API_URL.reports)) {
    return;
  }
  const reports = mockPaginate([createRandomReportList], { size: 10, page: 1 });

  axiosMock.onGet(prepareUrl(API_URL.reports, [id])).reply(200, reports);
};
